<template>
  <SearchFile 
    label="Saisissez le numéro de permis de l'actionnaire/associé"
    selectYourElementText="Sélectionnez le contact dans la liste"
    elementNonRepertorieText="Annuler"
    noResultsFoundText="Aucun membre trouvé. Si vous ne trouvez pas le membre, contactez-nous."
    maxWidth="600"
    :searchUrl="(keyword) => `/contacts/search-by-permit?keyword=${keyword}`"
    @elementSelected="pharmacienSelected"
    :fillKeywordAfterSelect="(element) => `${element.fullName} - ${element.licenseNumber}`"
    :rules="rules"
    :filterResults="filterResults"
  >
    <template v-slot:cardContent="{ element }">
      <h3>{{ element.fullName }}</h3>
      <p class="mb-0 caption">{{ element.licenseNumber }}</p>
    </template>
  </SearchFile>
</template>

<script>
import SearchFile from "@/components/Common/SearchFile"
export default {
  components: { SearchFile },
  props: { rules: Array, idToExclude: Array },
  methods: {
    pharmacienSelected(pharmacien) {
      this.$emit("pharmacien-selected", { ...pharmacien })
    },
    filterResults(item) {
      return this.idToExclude.indexOf(item.id) === -1
    }
  }
}
</script>

<style></style>